import {TimeRangeConstraintDataDto} from "../../../../../../common/apis/datatype/DataTypeConstraintDto";
import {ConstraintPluginProps} from "../ConstraintDataPlugin";
import {Grid} from "@mui/material";
import {DataTypeTranslationKey} from "../../DataTypeTranslationKey";
import {t} from "../../../../../../store/localization/TranslMessasge";
import React from "react";
import {TimeFormatsConverter} from "./TimeFormatsConverter";
import {TimePicker} from "../../../../../../components/fields/time/TimePicker";


export function TimeRangeConstraintPluginForm(props: Readonly<ConstraintPluginProps<TimeRangeConstraintDataDto>>) {
    const {data, onChange, errors} = props;

    function updateTimeFrom(value?: string | null) {
        onChange({
            ...data,
            timeFrom: TimeFormatsConverter.dayjsStringToStringTimePart(value),
        });
    }

    function updateTimeTo(value?: string | null) {
        onChange({
            ...data,
            timeTo: value === undefined ? null : TimeFormatsConverter.dayjsStringToStringTimePart(value),
        });
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <TimePicker
                        label={t(DataTypeTranslationKey.TIME_FROM)}
                        value={TimeFormatsConverter.timeStringToFullDateString(data.timeFrom)}
                        onChange={(t) => updateTimeFrom(t)}
                        error={errors?.timeFrom}/>
            </Grid>
            <Grid item xs={6}>
                <TimePicker
                        label={t(DataTypeTranslationKey.TIME_TO)}
                        value={TimeFormatsConverter.timeStringToFullDateString(data.timeTo)}
                        onChange={(t) => updateTimeTo(t)}
                        error={errors?.timeTo}/>
            </Grid>
        </Grid>
    );
}
